"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Wxpublc',
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      list: [],
      listLoading: true,
      listQuery: {
        type: 1,
        page: 1,
        total: 10
      }
    };
  },
  computed: {
    agentInfo: function agentInfo() {
      return this.$store.state.user.agentInfo;
    }
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this = this;
      var url = 'MpWeixin/getWxCfgList';
      var listQuery = Object.assign({}, this.listQuery, {
        page: this.listQuery.page - 1
      });
      this.$get(url, this.listQuery).then(function (res) {
        _this.listLoading = false;
        _this.list = res.list;
        _this.listQuery.total = res.total;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    /**
       * 上传代码
       */
    uploadCode: function uploadCode(row) {
      var _this2 = this;
      var that = this;
      this.$alert('确定将代码到该小程序吗？', '上传代码', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          if (action == 'confirm') {
            _this2.loadObj = _this2.$loading({
              lock: true,
              text: '正在提交~~~',
              spinner: 'el-icon-loading'
            });
            _this2.$post('WxOpen/uploadMiniCode', {
              wxmini_appid: row.app_id
            }).then(function (res) {
              row.mini_info.option_status = 2;
              _this2.$message({
                message: '上传成功,正在获取类目',
                type: 'success'
              });
              that.getMiniCategoryList(row, 2);
            }).catch(function (err) {
              _this2.loadObj.close();
            });
          }
        }
      });
    },
    /**
       * 获取小程序类目
       */
    getMiniCategoryList: function getMiniCategoryList(row) {
      var _this3 = this;
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var that = this;
      var params = {};
      this.$post('WxOpen/getMiniCategoryList', {
        wxmini_appid: row.app_id
      }).then(function (res) {
        if (res[0]) {
          if (type == 1) {
            _this3.loadObj = _this3.$loading({
              lock: true,
              text: '正在提交~~~',
              spinner: 'el-icon-loading'
            });
          }
          _this3.$message({
            message: '获取类目成功',
            type: 'success'
          });
          params[0] = res[0];
          params[0]['address'] = 'pages/index/index';
          params[0]['title'] = _this3.config.project_name;
          params[0]['tag'] = 'pages';
          params = JSON.stringify(params);
          _this3.auditMiniCode(row, params);
        } else {
          _this3.$message({
            message: '获取类目为空',
            type: 'error'
          });
        }
      }).catch(function (err) {
        _this3.loadObj.close();
      });
    },
    /**
       * 提交代码审核
       */
    auditMiniCode: function auditMiniCode(row, params) {
      var _this4 = this;
      this.$post('WxOpen/auditMiniCode', {
        wxmini_appid: row.app_id,
        audit_items: params
      }).then(function (res) {
        _this4.loadObj.close();
        _this4.$message({
          message: '提交审核成功',
          type: 'success'
        });
        row.mini_info.audit_status = 2;
        row.mini_info.option_status = 3;
      }).catch(function (err) {
        _this4.loadObj.close();
      });
    },
    /**
      * 刷新审核状态
      */
    refreshAudit: function refreshAudit(row) {
      var _this5 = this;
      this.$post('WxOpen/refreshMiniCodeAuditResult', {
        wxmini_appid: row.app_id,
        audit_id: row.mini_info.audit_id
      }).then(function (res) {
        row.mini_info.audit_status = res.audit_status;
        if (res.audit_status == 0) row.mini_info.option_status = 4;
        _this5.$message({
          message: '刷新状态成功',
          type: 'success'
        });
      });
    },
    /**
       * 发布代码
       */
    releaseCode: function releaseCode(row) {
      var _this6 = this;
      this.$post('WxOpen/releaseMiniCode', {
        wxmini_appid: row.app_id
      }).then(function (res) {
        row.mini_info.option_status = 6;
        _this6.$message({
          message: '发布成功',
          type: 'success'
        });
      });
    }
  }
};